import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import MeetingStatusDomainService from "../../../Domain/MeetingStatus/MeetingStatus.service";
const MeetingStatusBadge = (props) => {
    return (_jsx("span", { className: `badge badge-${MeetingStatusDomainService.getBadgeColor(props.meetingStatus)}`, children: props.meetingStatus.name }));
};
export default MeetingStatusBadge;
